import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemAgitation() {
  const pains = ['Buscás actividades en internet que no están pensadas para adultos mayores argentinos', 'El material que encontrás es en inglés, muy infantil o demasiado difícil', 'Tu familiar hace una actividad y después no tiene más. Se aburre y lo deja', 'No sabés si lo que hace le está sirviendo de verdad', 'Los domingos se van en buscar cosas que nunca quedan bien', 'Sentís que querés ayudar pero no tenés las herramientas para hacerlo bien'];
  return <section className="py-20 px-4 bg-sand" data-id="element-210">
      <div className="max-w-4xl mx-auto" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-212">
          <h2 className="text-3xl md:text-5xl font-bold text-blue-900 mb-8 leading-tight" data-id="element-213">
            ¿Cuántos días más va a estar la mente sin ejercitarse?
          </h2>
          <p className="text-xl text-slate-700 mb-6 leading-relaxed" data-id="element-214">
            Querés cuidar a ese adulto mayor que amás. Sabés que la estimulación
            cognitiva importa. Pero nadie te dijo que iba a ser tan difícil
            encontrar algo que funcione de verdad.
          </p>
          <p className="text-2xl font-bold text-amber-600" data-id="element-215">
            No es falta de voluntad. Es falta de un sistema.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-ivory rounded-3xl p-8 md:p-12 shadow-lg border border-stone-200" data-id="element-216">
          <h3 className="text-2xl font-bold text-red-600 mb-8 flex items-center gap-3 border-b border-stone-100 pb-4" data-id="element-217">
            <XCircle className="w-8 h-8" data-id="element-218" />
            Sin el Megapack
          </h3>

          <ul className="space-y-6" data-id="element-219">
            {pains.map((pain, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex gap-4 items-start" data-id="element-220">
                <span className="text-red-500 mt-1 flex-shrink-0" data-id="element-221">❌</span>
                <span className="text-lg text-slate-700" data-id="element-222">{pain}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-223">
          <p className="text-2xl md:text-3xl font-bold text-blue-900 italic" data-id="element-224">
            ¿Y si este fuera el último día que tu familiar pasa sin un sistema
            real de estimulación cognitiva?
          </p>
        </motion.div>
      </div>
    </section>;
}